/** Gameplay HUD labels (mechanics HUD). */
export const hudText = {
  health: 'HEALTH',
  stamina: 'STAMINA',
  hunger: 'FOOD',
  thirst: 'WATER',
  fatigue: 'REST',
  yourBag: 'Your bag',
  day: (n: number) => `Day ${n}`,
  stage: (n: number) => `stage ${n}`,
  loadedReset: 'Loaded',
};
